import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";

import {
  drawerWidth,
  mainLayoutStyles,
  showNotification,
} from "../../../../../constants";
import Header from "../../../../../common/Header";
import { FilterSection, SearchBar } from "../../components/components";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import GAReactionsTable from "../../components/GAReactionsTable/GAReactionsTable";
import { useReactionsContext } from "../../../../../providers/OrganizationAdmin/ReactionsProvider";
import {
  ReactionsSearch,
  deleteReaction,
  updateReaction,
} from "../../../../../modules/OrganizationReactions/hooks/ReactionsHooks";
import { Toast } from "../../../../../common/alert";
import { useAuth } from "../../../../../hooks";
import { getFilterReactions } from "../../hooks/GAReactionsHooks";
import ConfirmationModal from "../../../../../common/ConfirmationModal";
import FilterModalComponent from "../../../../../common/FilterModalComponent";
import { getDateRange } from "../../../../../modules/OrgProf/hook/Organizationhook";

const ReactionsContainer = () => {
  const { currentUser } = useAuth();
  const { allGAReactions, handleGetAllGAReactions, loading, setLoading } =
    useReactionsContext();

  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [statusFilterOptions, setStatusFilterOptions] = useState([]);
  const [creationDateFilterOptions, setCreationDateFilterOptions] = useState(
    []
  );
  const [reportedStatusOptions, setReportedStatusOptions] = useState([]);
  const [selected, setSelected] = useState([]);

  const [reactionsData, setReactionsData] = useState([]);

  useEffect(() => {
    // if (allGAReactions.length) {
    // } else {
    handleGetAllGAReactions();
    // }
  }, []);

  useEffect(() => {
    setReactionsData(allGAReactions);
  }, [allGAReactions]);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const handleDeleteReaction = async () => {
    try {
      setLoading(true);

      selected.forEach(async (item) => {
        let responseTemp = await deleteReaction(item);
        console.log("delete reaction response:", responseTemp);
      });
      await handleGetAllGAReactions();
      setSelected([]);
      showNotification("Reaction deleted successfully.");
      // Toast("success", "Reaction deleted successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error deleting reaction", error.message);
    } finally {
      setLoading(false);
      handleDeleteModalClose();
    }
  };

  const handleUpdateReactionStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        status,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      selected.forEach(async (item) => {
        let responseTemp = await updateReaction(item, dataTemp);
        console.log("update reaction response:", responseTemp);
      });
      await handleGetAllGAReactions();
      setSelected([]);
      showNotification("Reaction updated successfully.");
      // Toast("success", "reaction updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating reaction", error.message);
    } finally {
      setLoading(false);
    }
  };
  const handleUpdateReportedStatus = async (status) => {
    try {
      setLoading(true);
      let dataTemp = {
        reportedStatus: status,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      selected.forEach(async (item) => {
        let responseTemp = await updateReaction(item, dataTemp);
        console.log("update reaction response:", responseTemp);
      });
      await handleGetAllGAReactions();
      setSelected([]);

      showNotification("Reaction updated successfully.");
      // Toast("success", "reaction updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating reaction", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterReactions = async () => {
    let creationDateRange;
    if (creationDateFilterOptions && creationDateFilterOptions.length > 0) {
      creationDateRange = getDateRange(
        creationDateFilterOptions,
        "Creation Date"
      );
    }
    // console.log("filter clicked");
    setSelected([]);
    if (
      creationDateFilterOptions.length > 0 ||
      statusFilterOptions.length > 0 ||
      reportedStatusOptions.length > 0
    ) {
      let temp = await getFilterReactions(
        statusFilterOptions,
        // creationDateFilterOptions,
        creationDateRange,
        reportedStatusOptions,
        setLoading,
        handleFilterModalClose
      );
      setReactionsData(temp);
    }
    if (
      creationDateFilterOptions.length === 0 &&
      statusFilterOptions.length === 0 &&
      reportedStatusOptions.length === 0
    ) {
      setReactionsData(allGAReactions);
    }
  };
  const handleDeleteChip = (filterType, filterItem) => {
    if (filterType === "status") {
      setStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "creationDate") {
      setCreationDateFilterOptions([]);
      // setCreationDateFilterOptions((prevOptions) => prevOptions.filter((item) => item !== filterItem));
    } else if (filterType === "reportedStatus") {
      setReportedStatusOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    }
  };

  useEffect(() => {
    handleFilterReactions();
  }, [statusFilterOptions, creationDateFilterOptions, reportedStatusOptions]);

  const resetFilter = async () => {
    setStatusFilterOptions([]);
    setCreationDateFilterOptions([]);
    setReportedStatusOptions([]);
    setReactionsData(allGAReactions);
    setSelected([]);
  };

  const handleSearchReactions = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        // setSearchValue(value);
        // console.log(value);
        let reactionsSearchTemp = await ReactionsSearch(allGAReactions, value);
        setReactionsData(reactionsSearchTemp);
      } else {
        setReactionsData(allGAReactions);
        // setSearchValue(null);
      }
    } catch (error) {
      console.log("error searching quicktales:", error.message);
    }
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <Header mainTitle={"Reactions"} bgColor="#fff" />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            statusFilterOptions={statusFilterOptions}
            creationDateFilterOptions={creationDateFilterOptions}
            reportedStatusOptions={reportedStatusOptions}
            handleDeleteChip={handleDeleteChip}
          />
          <SearchBar
            selected={selected}
            setSelected={setSelected}
            handleSearch={handleSearchReactions}
            handleUpdateReactionStatus={handleUpdateReactionStatus}
            handleUpdateReportedStatus={handleUpdateReportedStatus}
            handleDeleteReaction={handleDeleteModalOpen}
            placeholder={"Search by QT Title"}
          />

          <GAReactionsTable
            selected={selected}
            setSelected={setSelected}
            reactionsData={reactionsData}
          />
        </Grid>
      </Grid>
      <ConfirmationModal
        modalOpen={deleteModal}
        handleClose={handleDeleteModalClose}
        handleClick={handleDeleteReaction}
        title={"Are you sure to delete the selected Reactions(s)?"}
        loading={loading}
      />
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterReactions}
        data={[
          {
            mainOptions: creationDateFilterOptions,
            setMainOptions: setCreationDateFilterOptions,
            type: "date",
            title: "Creation Date",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
          {
            mainOptions: statusFilterOptions,
            setMainOptions: setStatusFilterOptions,
            type: "text",
            title: "Reaction Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "pending", selected: false },
              { label: "approved", selected: false },
              { label: "denied", selected: false },
              { label: "removed", selected: false },
            ],
          },
          {
            mainOptions: reportedStatusOptions,
            setMainOptions: setReportedStatusOptions,
            type: "text",
            title: "Reported Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "reported", selected: false },
              { label: "in review", selected: false },
              { label: "pending", selected: false },
              { label: "resolved", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default ReactionsContainer;
